// extracted by mini-css-extract-plugin
export default {"main":"AssetPreview_main__cHO7M","idea":"AssetPreview_idea__2oOtr","ybl":"AssetPreview_ybl__hDok8","fintech":"AssetPreview_fintech__YHy75"};